import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ publicCLO }) => publicCLO;

const makeSelectGroupBy = () => createSelector(
  store,
  ({ groupBy }) => groupBy,
);

const makeSelectReportStatus = () => createSelector(
  store,
  ({ reportPending }) => reportPending,
);

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.sortBy(R.prop('index'), R.values(itemList)),
);


const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectGlobalFilterValue = () => createSelector(
  store,
  ({ globalFilterValue }) => globalFilterValue,
);

const makeSelectFilterProps = () => createSelector(
  store,
  ({ filterProps }) => filterProps,
);

export {
  makeSelectGroupBy,
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectFilterProps,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectAvailableReports,
  makeSelectGlobalFilterValue,
};

